'use client';
import { ExportWorkspace } from '../../components/desk/export-workspace';
export default function ExportsPage(){return <ExportWorkspace/>;}
